<template>
  <v-container class="d-flex justify-center align-center h-100">
    <v-card class="ma-4" style="width: 100%; max-width: 600px;">
      <v-card-text>
        <h3 class="mt-4">Testing Stablecoin Faucet</h3>
        <div class="mt-4">Receiving Wallet Address:</div>
        <v-text-field
            outlined
            hide-details
            class="mt-2"
            color="indigo darken-2"
            dense
            v-model="receiver"
        ></v-text-field>

        <h4 class="my-4">Amount: 100</h4>

        <div class="d-flex justify-end">
          <v-btn color="indigo darken-2" block dark @click="submit" :loading="submitLoading">Submit</v-btn>
        </div>

        <div class="pt-4 d-flex justify-end">
          <v-btn outlined block @click="registerStablecoin">Register token to wallet</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import config from "@/config";
import backendCall from "@/lib/backendCall";
import Vue from 'vue'

export default {
  name: "Stablecoin",
  data() {
    return {
      receiver: "",
      submitLoading: false
    }
  },
  methods: {
    async registerStablecoin () {
      const tokenAddress = config.blockchainConfig.contractAddresses.stablecoin;
      try {
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
              address: tokenAddress, // The address that the token is at.
              symbol: 'USDC(test)', // A ticker symbol or shorthand, up to 5 chars.
              decimals: config.commonConfig.paymentCoinDecimal, // The number of decimals in the token
            },
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    async submit() {
      try {
        this.submitLoading = true
        const res = await backendCall.faucet.stablecoinFaucet(this.receiver)
        if (res.status === 1) {
          Vue.notify({
            type: 'success',
            text: 'Payout success'
          })
        } else if (res.status === 0) {
          Vue.notify({
            type: 'error',
            text: res.message
          })
        }
      }catch (e) {
        console.log(e)
        Vue.notify({
          type: 'error',
          text: 'Payout may fail'
        })
      }finally {
        this.submitLoading = false
      }

    }
  }
}
</script>

<style scoped>

</style>